export const BRAND = {
  company:      "Dcode Private Limited",
  product:      "DPL Jade",
  productFull:  "J.A.D.E",
  acronym:      "Joint Aided Design Engine",
  tagline:      "Design. Calculate. Build.",
  subTagline:   "Browser-based architectural drafting with live cost estimation — no install, no CAD license.",
  description:  "J.A.D.E is a Joint Aided Design Engine for architects, contractors, and homeowners. Draw complete building layouts, get instant bill-of-quantities, and export construction drawings — all in your browser.",
  website:      "https://dplhomestar.com",
  appUrl:       "https://jade.dplhomestar.com",
  email:        "info@dplhomestar.com",
  supportEmail: "info@dplhomestar.com",
  legalName:    "Dcode Private Limited",

  // ── Fill these in before publishing legal pages ───────────────────────────
  // cin:       "U72900XX2024PTC000000",
  // gstin:     "29XXXXX0000X1ZX",
  // address:   "123 Example Road, Bengaluru, Karnataka 560001",

  registeredAddress: null,
  cin:               null,
  gstin:             null,

  year: 2024,
};

export const SOCIAL = {
  twitter:   "",
  linkedin:  "",
  instagram: "",
};
